import { useMutation, useQueryClient } from '@tanstack/react-query';

type CustomizeType = 'candidate_profile' | 'company' | 'candidate_interview_log';

interface UpdateCategoryParams {
  id: number;
  name: string;
  type: CustomizeType;
}

/**
 * カスタムカテゴリ更新用のフック
 */
export default function useUpdateCustomCategory() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, name }: UpdateCategoryParams) => {
      const response = await fetch(`/agent/api/custom_categories/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({
          name,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'カテゴリの更新に失敗しました');
      }

      return response.json();
    },
    onSuccess: (data, variables) => {
      // カテゴリ一覧のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['custom_categories', variables.type] });
      // カテゴリ詳細のキャッシュも無効化
      queryClient.invalidateQueries({ queryKey: ['custom_category', variables.id] });
    },
  });
}
